import { FC } from 'react'

import { SettingsPageLayout } from '../components/SettingsPageLayout'
import {
  EmptyState,
  IconKey,
  IndigoIndigo60,
  Link,
  SettingsGroup
} from '@sequencehq/core-components'

import { useQuery } from '@sequencehq/api'

import { SETTINGS_STALE_TIME } from '../settings.constants'

import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

import { ApiKeyCard } from 'SettingsV2/components/api-keys/ApiKeyCard'
import { CreateAPIKeyModal } from 'SettingsV2/components/api-keys/CreateApiKeyModal'

export const ApiKeysSettingsPage: FC = () => {
  const { data, isError, isLoading } = useQuery(
    dashboard20240730Client.getOAuthClients,
    { limit: 100 },
    {
      staleTime: SETTINGS_STALE_TIME
    }
  )

  return (
    <SettingsPageLayout
      header="API keys"
      subheader="Create and manage your personal API keys."
      isError={isError}
      actions={<CreateAPIKeyModal />}
    >
      <SettingsGroup isLoading={isLoading}>
        {data?.items?.map(apiKey => (
          <ApiKeyCard key={apiKey.id} apiKey={apiKey} />
        ))}

        {!data?.items.length && (
          <EmptyState
            title="No API keys"
            icon={IconKey}
            iconSize="sm"
            body={
              <>
                Create a new key to integrate with the Sequence API,{' '}
                <Link
                  _hover={{ textDecoration: 'none' }}
                  to="https://docs.sequencehq.com/reference/authentication"
                  color={IndigoIndigo60}
                  target="_blank"
                >
                  learn more
                </Link>
                .
              </>
            }
          />
        )}
      </SettingsGroup>
    </SettingsPageLayout>
  )
}
